
import React from "react";
import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface GridCardDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  itemTitle: string;
  onConfirm: () => void;
  isMultiDelete?: boolean;
}

const GridCardDeleteDialog = ({
  open,
  onOpenChange,
  itemTitle,
  onConfirm,
  isMultiDelete = false
}: GridCardDeleteDialogProps) => {
  const handleConfirm = () => {
    onConfirm();
    onOpenChange(false);
    
    // TEMPORARY FIX: Force page refresh after deletion
    setTimeout(() => {
      console.log('[GridCardDeleteDialog] Forcing page refresh after delete');
      window.location.reload();
    }, 100);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Trash2 className="h-5 w-5 text-red-500" />
            <span>Confirm Deletion</span>
          </DialogTitle>
        </DialogHeader>
        
        <DialogDescription className="py-4">
          {isMultiDelete ? (
            <>
              Are you sure you want to delete {itemTitle}?<br />
              This action cannot be undone.
            </>
          ) : (
            <>
              Are you sure you want to delete "{itemTitle}"?<br />
              This action cannot be undone.
            </>
          )}
        </DialogDescription>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={handleConfirm}>
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default GridCardDeleteDialog;
